export type Product = {
	no: string
	vendor_no: string
	status: 'published' | 'pending' | 'deleted'
	title: string
	descriptions: ProductDescription[]
	sample_proof: string[]
	banner_img: string[]
	lowest_price: number
	lowest_challenge_price: number
	is_deleted: boolean
	product_shippings?: ProductShipping[]
	create_date?: string
	modify_date?: string
	delete_date?: string | null
}
export type ProductDescription = {
	link: string | null
	path: string | null
	type: string
	filename: string | null
}
export type ProductShipping = {
	no: string
	courier_no: string
	product_no: string
	price?: number | null
	refund_price?: number | null
	estimated_delivery_date?: number
	product_courier: ProductCourier
	create_date?: string
	modify_date?: string
}
export type ProductCourier = {
	no: string
	status: string
	name: string
	code: string
	create_date?: string
	modify_date?: string
}

export const ProductStatusDisplay = {
	published: '등록됨',
	pending: '검토중',
	deleted: '삭제됨',
} as const
